import { ReactNode } from 'react';
import { FaUber } from 'react-icons/fa6';

interface Props {
  code: string;
  title: string;
  description: ReactNode;
}

export function UberPickupCode({ code, title, description }: Props) {
  return (
    <div className="flex w-[523px] flex-col items-start gap-2">
      <div className="flex items-start gap-2">
        <FaUber size={24} className="text-black" />
        <p className="text-sm font-bold text-neutral-500">{title}</p>
      </div>
      <p className="text-2xl text-neutral-500">{code}</p>
      <p className="w-full text-left text-xs text-neutral-500">{description}</p>
    </div>
  );
}
